module.exports = __webpack_public_path__ + "img/symbol_4.12de9dc9.png";